<template>
  <section>
    <vue-qr v-if="inline" :text="inlineText" :size="200" />
    <el-dialog
      :title="title"
      :lock-scroll="true"
      :visible.sync="dialogVisible"
    >
      <section class="qrcodeBox">
        <vue-qr :text="text" :size="200" />
      </section>
    </el-dialog>
  </section>
</template>

<script>
import VueQr from 'vue-qr';
export default {
  components: {
    VueQr,
  },
  props: {
    title: {
      type: String,
      default: '二维码',
    },
    inline: {
      type: Boolean,
      default: false,
    },
    inlineText: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      dialogVisible: false,
      text: '',
    };
  },
  methods: {
    show (text) {
      this.text = text;
      this.dialogVisible = true;
    },
  },
};
</script>

<style scoped lang="scss">
.qrcodeBox{
  text-align: center;
  padding-bottom: 20px;
}
</style>
